<template>
	<div>
		<div 
			v-for="optionGroup in options" 
			:class="['dc-post-grid-option-accordion-group-wrapper', {
				'open': (openAccordion===optionGroup.parent_term.value)
			}]">
			<button 
				type="button"
				v-if="optionGroup.options.length>0"
				:aria-expanded="openAccordion===optionGroup.parent_term.value"
				:id="'options-label-' + optionGroup.parent_term.value"
				class="dc-post-grid-option-accordion-title"
				:aria-controls="'options-' + optionGroup.parent_term.value"
				@click.stop.prevent="toggleAccordion(optionGroup.parent_term.value)"
				>{{ optionGroup.parent_term.label }}</button>
			<OptionsList 
				:id="'options-' + optionGroup.parent_term.value"
				:class="['dc-post-grid-option-accordion-group-options']"
				role="region"
				:aria-labelledby="'options-label-' + optionGroup.parent_term.value"
				:showAllOption="showAllOption"
				:checkedValues="checkedValues"
				:fieldName="fieldName"
				:options="optionGroup.options" 
				v-on:update-filter="choose"
				/>
		</div> 
	</div>
</template>

<script>
import OptionsList from './OptionsList';
import { Translatable } from '@dc-post-grid/mixins/Translatable';
export default {
	mixins: [Translatable],
	props: {
		checkedValues: {
			type: Array,
			required: true,
		},
		options: {
			type: Array,
			required: true,
		},
		fieldName: {
			type: String,
			required: true,
		},
		showAllOption: {
			type: Boolean,
			required: true,
		}
	},
	data() {
		return {
			openAccordion: '',
		}
	},
	methods: {
		choose(value, label) {
			this.$emit('update-filter', value, label);
		},
		toggleAccordion(value) {
			this.openAccordion = (value===this.openAccordion) ? '' : value
		}
	},
	components: {
		OptionsList
	}
}
</script>
